<template>
    <div>
        <div class="modal hide fade" id="modalProcessAsset" tabindex="-1" role="dialog" aria-labelledby="modalProcessAsset" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Process Asset
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dl class="row">
                                    <dd class="col-sm-4"><strong>Date:</strong></dd>
                                    <dd class="col-sm-8">
                                        <datetime v-model="date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" ></datetime>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-hard-primary" data-dismiss="modal" @click="process">Process</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'AssetModal',
  data () {
    return {
      date: new Date().toISOString()
    }
  },
  methods: {
    process () {
      this.$emit('processDate', this.date)
    }
  }
}
</script>
